import type { AuthUser } from '@/contexts/authStateContext';

/** Имя вошедшего на кнопке меню пользователя: имя и фамилия, без них — почта, без почты — «Пользователь». */
export function authUserDisplayName(user: Pick<AuthUser, 'first_name' | 'last_name' | 'email'>): string {
  const fullName = [user.first_name, user.last_name].filter(Boolean).join(' ').trim();
  return fullName || user.email || 'Пользователь';
}
